module.exports = {"Description":"MC : 980NN","RedundantCharacters":" -","ValidationRegex":"^980[0-9]{2}$","TestData":{"Valid":["98000","98099"],"Invalid":["98100","97099"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/MC.json
// module id = 4471
// module chunks = 11